// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ActivityLog page */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.search-bar {
  display: flex;
  gap: 8px;
  margin-bottom: 15px;
}

.search-bar input {
  flex: 1 1;
  padding: 10px 15px;
  border: 1px solid #40444b;
  border-radius: 5px;
  background: #2f3136;
  color: #fff;
  font-size: 14px;
}

.search-bar input::placeholder {
  color: #72767d;
}

.search-btn {
  background: #5865f2;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
}

.search-btn:hover {
  background: #4752c4;
}

.log-filters {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-group label {
  color: #b9bbbe;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.filter-group select {
  padding: 8px 12px;
  border: 1px solid #40444b;
  border-radius: 4px;
  background: #2f3136;
  color: #fff;
  font-size: 13px;
}

.log-table-container {
  overflow-x: auto;
  border-radius: 8px;
}

.log-table {
  width: 100%;
  border-collapse: collapse;
  background: #2f3136;
  border-radius: 8px;
  overflow: hidden;
}

.log-table thead {
  background: #202225;
}

.log-table th {
  text-align: left;
  padding: 12px 15px;
  color: #b9bbbe;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600;
  border-bottom: 2px solid #40444b;
}

.log-table td {
  padding: 10px 15px;
  border-bottom: 1px solid #40444b;
  font-size: 13px;
  color: #dcddde;
}

.log-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.02);
}

.log-table tbody tr:last-child td {
  border-bottom: none;
}

.log-timestamp {
  color: #72767d;
  font-size: 12px;
  white-space: nowrap;
}

.action-badge {
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: bold;
  color: white;
  text-transform: capitalize;
}

.entity-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  text-transform: capitalize;
}

.entity-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background: #202225;
  border-radius: 4px;
  font-size: 10px;
  font-weight: bold;
  color: #5865f2;
}

.log-description {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.log-user {
  color: #72767d;
  font-size: 12px;
}

.no-logs {
  text-align: center;
  color: #72767d;
  padding: 40px !important;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
}

.page-btn {
  background: #2f3136;
  color: #b9bbbe;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.page-btn:hover:not(:disabled) {
  background: #5865f2;
  color: white;
}

.page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.page-info {
  color: #b9bbbe;
  font-size: 13px;
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 40px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #40444b;
  border-top-color: #5865f2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/ActivityLog.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* ActivityLog page */\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.search-bar {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 15px;\n}\n\n.search-bar input {\n  flex: 1;\n  padding: 10px 15px;\n  border: 1px solid #40444b;\n  border-radius: 5px;\n  background: #2f3136;\n  color: #fff;\n  font-size: 14px;\n}\n\n.search-bar input::placeholder {\n  color: #72767d;\n}\n\n.search-btn {\n  background: #5865f2;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.search-btn:hover {\n  background: #4752c4;\n}\n\n.log-filters {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.filter-group label {\n  color: #b9bbbe;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.filter-group select {\n  padding: 8px 12px;\n  border: 1px solid #40444b;\n  border-radius: 4px;\n  background: #2f3136;\n  color: #fff;\n  font-size: 13px;\n}\n\n.log-table-container {\n  overflow-x: auto;\n  border-radius: 8px;\n}\n\n.log-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #2f3136;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.log-table thead {\n  background: #202225;\n}\n\n.log-table th {\n  text-align: left;\n  padding: 12px 15px;\n  color: #b9bbbe;\n  font-size: 12px;\n  text-transform: uppercase;\n  font-weight: 600;\n  border-bottom: 2px solid #40444b;\n}\n\n.log-table td {\n  padding: 10px 15px;\n  border-bottom: 1px solid #40444b;\n  font-size: 13px;\n  color: #dcddde;\n}\n\n.log-table tbody tr:hover {\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.log-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.log-timestamp {\n  color: #72767d;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.action-badge {\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: bold;\n  color: white;\n  text-transform: capitalize;\n}\n\n.entity-badge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  text-transform: capitalize;\n}\n\n.entity-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  background: #202225;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: bold;\n  color: #5865f2;\n}\n\n.log-description {\n  max-width: 300px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.log-user {\n  color: #72767d;\n  font-size: 12px;\n}\n\n.no-logs {\n  text-align: center;\n  color: #72767d;\n  padding: 40px !important;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n  margin-top: 20px;\n}\n\n.page-btn {\n  background: #2f3136;\n  color: #b9bbbe;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.page-btn:hover:not(:disabled) {\n  background: #5865f2;\n  color: white;\n}\n\n.page-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.page-info {\n  color: #b9bbbe;\n  font-size: 13px;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  padding: 40px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #40444b;\n  border-top-color: #5865f2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
